import "./works.scss"


export default function Works() {

    
    return <div className="works" id="works">

        <div className="left"> 
            <div className="imgContainer">
                <img src="assets/fixItFelixJr.gif" alt="" />
            </div>


        </div>
        <div className="right"> 
            <div className="wrapper">
                <h2>Fix It Felix Jr. Video Game </h2>
                <h1>Made in Java</h1>
                <h3>| 2018 - UNLP | </h3>
                <a href="#blockchain">
                    <img src="assets/arrow.png" alt=""/>
                </a>
            </div>  
        </div>
    </div>;
}
